import { useQuery } from "@tanstack/react-query"

import type { WorkflowResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getSharedWorkflows(): Promise<WorkflowResponse> {
  return api.get("/explorer/workflows/shared")
}

/**
 * Flows shared with the current user (direct or via group). Each item carries
 * `visibility: "shared"` and the viewer's granted `shared_role`. Separate from
 * useGetWorkflows (which returns only the user's own personal + company flows).
 */
export function useGetSharedWorkflows() {
  return useQuery({
    queryKey: queryKeys.sharedWorkflows,
    queryFn: () => getSharedWorkflows(),
    enabled: true,
  })
}
